export enum SettingValueType {
    String = "string",
    Integer = "integer",
    Boolean = "boolean",
    Text = "text",
  }
  